export function calculateActionsTarget(currentActions: number): number {
  /*
   * The target should be more than the current number of signatures.
   * but it should seem achievable from the current number of signatures.
   * Start with a goal of 100, then double that over and over until we have more
   * than the current number of signatures.
   *
   * This is the same algorithm that speakout uses.
   */
  const n = (currentActions + 1) * (5 / 4);
  const m = [2, 2.5, 2];
  let target = 100;
  let i = 0;

  while (n > target) {
    target = target * m[i % m.length];
    i = i + 1;
  }

  return target;
}
